import consumer from "./consumer"

// Action Cable channel that streams live job-run updates (log lines, progress,
// status) into the job page. Vanilla JS — no jQuery. Behaviour matches the
// legacy version exactly: it finds the [data-job-id] container, subscribes once
// per element, and updates the log stream / progress bar / status badge as
// messages arrive, reloading the page when the run finishes or fails.

function subscribeJobRunUpdates() {
  const container = document.querySelector("[data-job-id]")
  if (!container) return

  // jQuery `.data('job-id')` coerced numeric strings to numbers; the channel
  // params are JSON-serialised either way, so read the raw dataset value and
  // bail only when it's empty/absent (matches the old `if (!jobId)` guard).
  const jobId = container.dataset.jobId
  if (!jobId) return

  // Prevent duplicate subscription (legacy stored this via $.data('job-sub')).
  if (container.dataset.jobSub === "true") return
  container.dataset.jobSub = "true"

  consumer.subscriptions.create(
    { channel: "JobRunChannel", job_id: jobId },
    {
      connected() {
        console.log("Job run channel connected for job " + jobId)
      },

      disconnected() {
        console.log("Job run channel disconnected for job " + jobId)
      },

      received(data) {
        switch (data.type) {
          case "log":
            appendLogLine(data.line)
            break
          case "progress":
            updateProgress(data.value)
            break
          case "status":
            updateStatus(data.value, data.progress)
            break
        }
      },
    }
  )
}

function appendLogLine(line) {
  const log = document.querySelector(".job-log-stream")
  if (!log) return

  const lineEl = document.createElement("div")
  lineEl.textContent = line
  log.prepend(lineEl)
}

function updateProgress(value) {
  const bar = document.querySelector(".job-progress-bar")
  if (!bar) return

  const rounded = Math.round(value * 10) / 10
  bar.style.width = rounded + "%"
  bar.setAttribute("aria-valuenow", rounded)
  bar.textContent = rounded + "%"
}

function updateStatus(value, progress) {
  const badge = document.querySelector(".job-status-badge")
  if (badge) {
    badge.textContent = value.toUpperCase()
    badge.classList.remove("bg-primary", "bg-success", "bg-danger", "bg-warning")
    if (value === "finished") {
      badge.classList.add("bg-success")
    } else if (value === "failed") {
      badge.classList.add("bg-danger")
    } else {
      badge.classList.add("bg-primary")
    }
  }

  // On completion, reload page to show final run in accordion.
  if (value === "finished" || value === "failed") {
    setTimeout(function () {
      window.location.reload()
    }, 1500)
  }
}

document.addEventListener("turbo:load", subscribeJobRunUpdates)
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", subscribeJobRunUpdates)
} else {
  subscribeJobRunUpdates()
}
